module.exports = __webpack_public_path__ + "img/clickcompany.7753b4b0.svg";